/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbSharedRefineMenuDisplayPrefsSelect_filters = $ReadOnlyArray<{|
  +name: ?string;
  +values: ?$ReadOnlyArray<?{|
    +displayName: ?string;
    +urlLabel: ?string;
    +link: ?string;
  |}>;
|}>;
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SbSharedRefineMenuDisplayPrefsSelect_filters",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "name",
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 15,
          "type": "Int"
        }
      ],
      "concreteType": "SearchBrowseFilterValue",
      "name": "values",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "displayName",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "urlLabel",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "link",
          "storageKey": null
        }
      ],
      "storageKey": "values{\"limit\":15}"
    }
  ],
  "type": "SearchBrowseFilter"
};

module.exports = fragment;
